import { useQuery } from '@tanstack/react-query';
import { useFetcher } from '../../graphql';

export interface ActiveCallForIssue {
  id: string;
  room: string;
  state: string;
}

/**
 * Polls for the active group call on an Issue (Activity) so a bystander's
 * Activity screen can show a "call in progress" pill. Polling (not a
 * subscription) keeps this in step with the resolver, which is a raw-db,
 * no-perm-gate lookup.
 */
export const useActiveCallForIssue = (issueId?: string) => {
  const fetcherFn = useFetcher<
    { call: { activeCallForIssue: ActiveCallForIssue | null } },
    { issueId: string }
  >(ACTIVE_CALL_FOR_ISSUE);

  return useQuery({
    queryKey: ['activeCallForIssue', issueId],
    queryFn: async (): Promise<ActiveCallForIssue | null> => {
      const data = await fetcherFn({ issueId: issueId as string });
      return data.call.activeCallForIssue;
    },
    enabled: !!issueId,
    refetchInterval: 3000,
  });
};

const ACTIVE_CALL_FOR_ISSUE = `
  query ACTIVE_CALL_FOR_ISSUE($issueId: ID!) {
    call {
      activeCallForIssue(issueId: $issueId) {
        id
        room
        state
      }
    }
  }
`;
